import { render, staticRenderFns } from "./NoMobile.vue?vue&type=template&id=a7f07f24&scoped=true"
import script from "./NoMobile.vue?vue&type=script&lang=js"
export * from "./NoMobile.vue?vue&type=script&lang=js"
import style0 from "./NoMobile.vue?vue&type=style&index=0&id=a7f07f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f07f24",
  null
  
)

export default component.exports